import { MAX_REMOTE_VIDEOS_ON } from 'constants/config'
import { videoConstraints } from 'helpers/twilio'
import { isDesktop } from 'utils/device'

export const initialSettings = {
    trackSwitchOffMode: 'detected',
    dominantSpeakerPriority: 'high',
    bandwidthProfileMode: 'presentation',
    maxTracks: MAX_REMOTE_VIDEOS_ON, // only include RemoteTracks, 0 means unlimited
    maxAudioBitrate: !isDesktop ? '10000' : '16000',
    maxVideoBitrate: !isDesktop ? '1500000' : '2000000',
    LogLevel: 'debug',
    video: {
        ...videoConstraints.default,
    },
}

// This inputLabels object is used by ConnectionOptions.tsx. It is used to populate the id, name, and label props
// of the various input elements. Using a typed object like this (instead of strings) eliminates the possibility
// of there being a typo.
export const inputLabels = (() => {
    const target = {}
    for (const setting in initialSettings) {
        target[setting] = setting
    }
    return target
})()

export function settingsReducer(state, action) {
    return {
        ...state,
        [action.name]: action.value === 'default' ? undefined : action.value,
    }
}
